import axios from "axios";

export function usePortalConfig(){
    const get = async ({onResult})=>{
        try {
            let {data} = await axios.get(`config.json`);
            onResult(data);
        }
        catch ({response}) {
        }
    }

    return{get}
}